import { withInstall } from '@element-plus/utils'

import TextEllipsis from './src/text-ellipsis.vue'

export const ElTextEllipsis = withInstall(TextEllipsis)
export default ElTextEllipsis

export * from './src/text-ellipsis'
